import IconCalendar from 'assets/icons/calendar-2.svg';
import IconTruck from 'assets/icons/delivery-truck-2.svg';
import cn from 'classnames';
import { useConfig } from 'config/use-config';
import { useIsExistingCustomer } from 'hooks/common/use-is-existing-customer';
import { PRE_ORDER_SHIPPING_DATE } from 'modules/product-details/components/buy-panel/constants';
import React from 'react';
import { FormattedMessage } from 'react-intl';

interface ShippingElementProps {
  className?: string;
  isPreorderProduct: boolean;
  isVariantAvailable?: boolean;
}

/**
 * Component that displays the shipping information of the product.
 */
const ShippingElement: React.FC<ShippingElementProps> = ({
  className,
  isPreorderProduct,
  isVariantAvailable,
}) => {
  const { shippingTime } = useConfig();
  const { isEc } = useIsExistingCustomer();

  return (
    <div className={cn('text-text-secondary w-full items-center text-sm', className)}>
      <div className="mb-2 flex items-center">
        <IconTruck className="mr-1.5 h-5 w-5 shrink-0" />
        <FormattedMessage
          id={
            isEc
              ? 'pdp:buy-panel:free-shipping-existing-customer:without-style'
              : 'pdp:buy-panel:free-shipping-new-customer:without-style'
          }
        />
      </div>
      {isVariantAvailable && (
        <div className="mt-2 flex items-center lg:mt-0">
          <IconCalendar className="mr-1.5 h-5 w-5 shrink-0" />
          {isPreorderProduct ? (
            <FormattedMessage
              id="pdp:buy-panel:pre-order-shipping-date"
              values={{ value: PRE_ORDER_SHIPPING_DATE }}
            />
          ) : (
            <FormattedMessage id="pdp:buy-panel:shipping-time" values={{ value: shippingTime }} />
          )}
        </div>
      )}
    </div>
  );
};

export default ShippingElement;
